import {
	fetchCartWithSections,
	getDOMCart,
	getDOMCartSectionApiIds,
} from '@/scripts/core/cart-functions'
import { CartDrawer } from '@/scripts/cart/cart-drawer'

export async function refreshCartSectionsForStandardAction() {
	const sectionIds = getDOMCartSectionApiIds()
	const cartElement = getDOMCart()
	if (!sectionIds?.length || !cartElement) return

	const renderedCart = await fetchCartWithSections(sectionIds)

	if (cartElement.localName === CartDrawer.htmlSelector) {
		;(cartElement as CartDrawer).renderContents(renderedCart, false)
		return
	}
	cartElement.renderContents(renderedCart)
}
